module.exports = __webpack_public_path__ + "img/FG.3c54fd73.png";